import { poll } from '@mv/core/utils/promises';
import { getZendeskChat } from './zendeskChat';

export default class ChatService {
	private _isAvailable: Promise<boolean> | null = null;

	public async isAvailable(): Promise<boolean> {
		if (getZendeskChat()) return true;

		this.startCheckingIfAvailable();
		return this._isAvailable || false;
	}

	public async openChatModal(): Promise<boolean> {
		if (!(await this.isAvailable())) return false;

		const zendeskChat = getZendeskChat();
		if (!zendeskChat) return false;

		zendeskChat('messenger', 'show');
		zendeskChat('messenger', 'open');
		return true;
	}

	private startCheckingIfAvailable() {
		if (this._isAvailable) return;
		this._isAvailable = poll(
			async () => typeof window.zE === 'function',
			(av) => av,
			500,
			5_000,
			'',
		).catch(() => false);
	}

	public async setLocale(locale: string) {
		if (await this.isAvailable()) {
			getZendeskChat()?.('messenger:set', 'locale', locale);
		}
	}
}
